import { render, staticRenderFns } from "./Governorate.vue?vue&type=template&id=40748f7e&scoped=true"
import script from "./Governorate.vue?vue&type=script&lang=js"
export * from "./Governorate.vue?vue&type=script&lang=js"
import style0 from "./Governorate.vue?vue&type=style&index=0&id=40748f7e&prod&scoped=true&lang=css"
import style1 from "./Governorate.vue?vue&type=style&index=1&id=40748f7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40748f7e",
  null
  
)

export default component.exports